import React, { Component } from 'react';
import * as img from '../../lib/images';
import * as env from '../../lib/environment';

import MyButton from '../button'

const Storage = (props) => {
    if (props.isMobile) {
        return (
            <div className="d-flex headerSection align-items-center ">

                <div className="col-12  h-100 d-flex justify-content-center flex-column">
                    {/* <p className="m-0" style={{fontSize:'2.5rem',fontWeight:"bold"}}>Our Story  </p> */}
                    <div style={{ padding: "2rem 0rem" }}>
                        <p className="" style={{ fontSize: "0.98rem", textAlign: "center" }}>Self Storage facilities provide a valuable service to local families and
                        communities around them. The Self-storage industry has a strong
                        presence in North America, Europe, Australia and Singapore. In the US
                         alone, it is a 38 billion dollar industry. India and China are leading the
                emerging markets in Asia-Pacific. </p>
                    </div>
                    <div data-aos="fade-up-right"  className="w-100 d-flex justify-content-center ">
                        <img className="storageImage" src={img.STORAGE_IMAGE} />
                    </div>
                    <div className="w-100 d-flex pt-5 justify-content-center ">
                        <MyButton value="Know More" />
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div   className="d-flex headerSection align-items-center leftSection">
                <div data-aos="fade-up-right" className="col-6 d-flex justify-content-start px-0 py-3 h-100">
                    <img className="storageImage" src={img.STORAGE_IMAGE} />
                </div>
                <div className="col-6 pl-5 h-100 d-flex justify-content-center flex-column">
                    {/* <p className="m-0" style={{fontSize:'2.5rem',fontWeight:"bold"}}>Our Story  </p> */}
                    <div style={{ padding: "3rem 0rem" }}>
                        <p className="" style={{ fontSize: "0.98rem" }}>Self Storage facilities provide a valuable service to local families and
                        communities around them. The Self-storage industry has a strong
                        presence in North America, Europe, Australia and Singapore. In the US
                         alone, it is a 38 billion dollar industry. India and China are leading the
                emerging markets in Asia-Pacific. </p>
                    </div>


                    <button style={{ borderRadius: '30px', border: "1px solid gray", background: "#fff", width: '14rem', height: "3rem" }}>Know More</button>
                </div>


            </div>
        )
    }

}

export default Storage;